module.exports = __webpack_public_path__ + "img/Bonus_Uhrd.e9f15018.svg";